<app-input-label [inputId]="id" [inputName]="name" [mandatory]="mandatory" [helpTooltipText]="helpTooltipText"></app-input-label>

<ng-container *ngIf="isLoading">
  <div class="loading-placeholder-container">
    <app-loading-placeholder></app-loading-placeholder>
  </div>
</ng-container>

<ng-container *ngIf="!isLoading">
  <ng-container *ngIf="!hasError">
    <div class="input-container">
      <input [attr.list]="idList"
        [name]="name"
        [id]="id"
        class="datalist-input input"
        [autocomplete]="autocomplete"
        [placeholder]="placeholderText"
        [disabled]="isDisabled"
        [(ngModel)]="value"
        (blur)="onTouched($event)"
        (ngModelChange)="handleInput()" >
      <datalist [id]="idList" >
        <option [value]="undefined" disabled hidden>{{ placeholderText }}</option>

        <option [value]="null" [disabled]="hideNullOption" [hidden]="hideNullOption">{{ placeholderText }}</option>

        <ng-container *ngFor="let item of possibleValues">
          <option [value]="item" [selected]="item === value">{{ getItemDisplayValue(item) }}</option>
        </ng-container>
      </datalist>


      <div class="datalist-icon">
        <app-lucide-icon [iconName]="'chevron-down'" [size]="36"></app-lucide-icon>
      </div>

    </div>
  </ng-container>

  <ng-container *ngIf="hasError">
    <app-error [error]="error"></app-error>
  </ng-container>
</ng-container>
